<template>
    <div>
        <v-menu v-model="menu" :close-on-content-click="false" transition="scale-transition" offset-y min-width="290px">
            <template #activator="{ on }">
                <b-filter-input
                    ref="input"
                    v-bind="$attrs"
                    :label="label"
                    class="date-filter"
                    readonly
                    :clearable="$attrs.value && $attrs.value !== null"
                    @click:clear="onClear"
                    v-on="on"
                ></b-filter-input>
            </template>
            <v-date-picker
                width="290px"
                v-bind="$attrs"
                :title-date-format="(val) => selectedText(val)"
                v-on="$listeners"
            >
                <v-card-actions>
                    <v-btn text rounded color="primary" @click="onClose"> {{ t('default::button.close') }} </v-btn>
                </v-card-actions>
            </v-date-picker>
        </v-menu>
    </div>
</template>

<script>
export default {
    name: 'BFilterDate',
    props: {
        label: {
            type: String,
            required: true,
        },
    },
    data() {
        return {
            menu: false,
        };
    },
    computed: {},
    created() {},
    methods: {
        onClose() {
            this.menu = false;
            return this.$emit('close');
        },
        onClear() {
            return this.$emit('clear');
        },
        selectedText(value) {
            if (typeof this.$attrs.range == 'undefined') {
                let date = moment(value).format('ll');
                if (this.$attrs.type === 'month') {
                    date = moment(value).format('MMM Y');
                }
                return `<div class="selected-date">
                <div class="date-selected">${date}</div>
            </div>`;
            }
            let date = value;
            if (value.length === 1) {
                date = moment(value[0]).format(this.$root.dateFormat);
            }
            if (value.length === 2) {
                date = `${moment(value[0]).format(this.$root.dateFormat)} - ${moment(value[1]).format(
                    this.$root.dateFormat
                )}`;
            }
            return `<div class="selected-date">
                <div class="date-selected">${date}</div>
                <div class="date-hint">${t('default::filter.date.hint')}</div>
            </div>`;
        },
    },
};
</script>
